import { render, staticRenderFns } from "./HeartAbout.vue?vue&type=template&id=4eb5e584"
import script from "./HeartAbout.vue?vue&type=script&lang=js"
export * from "./HeartAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports